import { MessageType } from "./message-type.model";

export interface Message {
    translationKey: string,
    type: MessageType,

    icon?: string,
    duration?: number
  }
